import React from "react";

const MovieMenuIcon = ({ className="" }) => {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g id="film_reel" data-name="film reel" fill="currentColor"><path d="m13 16a4 4 0 1 0 -4 4 4 4 0 0 0 4-4zm-4 2a2 2 0 1 1 2-2 2 2 0 0 1 -2 2z"/><path d="m17 16a4 4 0 1 0 4-4 4 4 0 0 0 -4 4zm4-2a2 2 0 1 1 -2 2 2 2 0 0 1 2-2z"/><path d="m15 14a4 4 0 1 0 -4-4 4 4 0 0 0 4 4zm0-6a2 2 0 1 1 -2 2 2 2 0 0 1 2-2z"/><path d="m19 22a4 4 0 1 0 -4 4 4 4 0 0 0 4-4zm-6 0a2 2 0 1 1 2 2 2 2 0 0 1 -2-2z"/><path d="m29 27h-7.1a13 13 0 1 0 -6.9 2h14a1 1 0 0 0 0-2zm-25-11a11 11 0 1 1 11 11 11 11 0 0 1 -11-11z"/></g></svg>
    );
};

export default MovieMenuIcon;
